<template>
  <div class="content-area">
    <hero-bar>
      {{ $t('vehicleTypes') }}

      <b-tooltip slot="right" :label="$t('refresh')" type="is-dark" position="is-bottom">
        <b-button
          id="refresh-button"
          class="mr-10"
          size="is-circle"
          type="is-link"
          outlined
          :class="{ 'is-loading': refreshLoading }"
          icon-left="refresh"
          @click="refresh"
        />
      </b-tooltip>

      <!-- <b-button
        v-if="checkPermission('create_specification')"
        id="new-plan"
        slot="right"
        tag="router-link"
        :to="{ name: 'vehicle_types.create'}"
        icon-left="plus-circle"
        type="is-link"
      >
        {{ $t('createVehicleType') }}
      </b-button> -->
    </hero-bar>

    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <vehicle-types-table
          id="vehicleTypesTable"
          ref="vehicleTypesTable"
          data-url="/vehicle-types"
          @excelChange="actionExcelChange"
          @loadingChange="actionLoadingChange"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
export default {
  title: ({ $i18n }) => $i18n.t('vehicleTypes'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    VehicleTypesTable: () => import('@/components/VehicleTypesTable'),
  },
  data () {
    return {
      rexcelLoading: false,
      refreshLoading: false,
    }
  },
  methods: {
    refresh () {
      document.getElementById('refresh-button').blur()
      this.refreshLoading = true
      this.$refs.vehicleTypesTable.loadVehicleTypes()
    },
    actionExcelChange (e) {
      setTimeout(() => {
        this.excelLoading = e
      }, 500)
    },
    actionLoadingChange (e) {
      this.refreshLoading = e
    },
  }
}
</script>
